<app-service-notifications />
<header class="lg:container flex flex-col-reverse items-center gap-4 lg:flex-row lg:justify-between pb-4 lg:py-7">
  <div class="flex items-center">
    <img src="/images/logo.svg" width="100" alt="GF Card" />
    <img src="/images/card.svg" alt="Visa" class="ps-6 ms-6 border-l border-l-slate-400 py-3" />
  </div>
  <p
    class="block shadow lg:shadow-none w-full lg:w-auto text-sm text-center bg-white lg:bg-transparent lg:text-right py-0.5"
  >
    <span class="hidden lg:inline">Asiakaspalvelu</span>
    <a [href]="`tel:${environment.phone}`" class="text-sm lg:text-lg font-bold no-underline!"
      ><img src="/images/icons/cellar.svg" class="inline-block mx-1" alt="" /> {{ environment.phone }}</a
    >
    <span class="hidden lg:inline-block ps-1">(pvm/mpm) | ti-to 10-14 (ei pyhäpäivisin)</span>
    <br />
    <a [href]="`mailto:${environment.email}`" class="text-sm no-underline!"
      ><img src="/images/icons/email.svg" class="inline-block mx-1" alt="" /><span>{{ environment.email }}</span>
      <span class="hidden lg:inline-block">| tiistaisin - torstaisin 10-14</span></a
    >
  </p>
</header>
<main class="container bg-white lg:rounded-4xl shadow-xl overflow-hidden mb-10 px-0!">
  <router-outlet />
</main>
<footer class="container">
  <address class="not-italic">
    <span>GF Money Oy</span>
    <span>{{ environment.companyAddress }}</span>
    <span>20250 {{ environment.companyCity }}</span>
    <span>Y-tunnus: {{ environment.companyId }}</span>
  </address>
  <div>
    <img src="/images/icons/cellar.svg" class="inline-block me-1" alt="" /> Puhelin:
    <a [href]="`tel:${environment.phone}`">{{ environment.phone }}</a>
  </div>
  <div>
    <img src="/images/icons/email.svg" class="inline-block me-1" alt="" />
    <a [href]="`mailto:${environment.email}`">{{ environment.email }}</a>
  </div>
</footer>

<app-success-message></app-success-message>
<app-error-message></app-error-message>
